(() => {
  const configNode = document.getElementById('ForgeFlowText');
  if (!configNode || window.forgeFlowReady) return;
  window.forgeFlowReady = true;
  const cfg = JSON.parse(configNode.textContent, (key, value) => {
    if (typeof value !== 'string' || !value.includes('&')) return value;
    const field = document.createElement('textarea');
    field.innerHTML = value;
    return field.value;
  });
  const rootPath = (cfg.root || '/').replace(/\/?$/, '/');
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const make = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cfg.currency || 'USD'}).format(cents / 100);
  const fill = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll('[' + key + ']', String(value)), text);
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const life = new AbortController();
  window.addEventListener('pagehide', event => {if (!event.persisted) life.abort();});
  if (cfg.previewThemeId) {
    const preservePreview = () => {
      const url = new URL(location.href);
      if (url.searchParams.get('preview_theme_id') === String(cfg.previewThemeId)) return;
      url.searchParams.set('preview_theme_id', cfg.previewThemeId);
      history.replaceState({}, '', url);
    };
    preservePreview();
    window.addEventListener('load', preservePreview, {once:true});
  }

  function sizeLabel(value) {
    const panel = String(value).match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (panel) return panel[1] + '×' + panel[2] + ' in';
    const figure = String(value).match(/(\d+(?:\.\d+)?)\s*[”"″]?\s*(?:in(?:ches)?\b|[”"″])/i);
    return figure ? figure[1] + ' in' : '';
  }

  function initializeMenus(scope) {
    qa('[data-forge-menu]', scope).forEach(menu => {
      if (menu.dataset.flowReady) return;
      menu.dataset.flowReady = 'true';
      document.addEventListener('click', event => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      }, {signal:life.signal});
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          q('summary', menu).focus();
        }
      }, {signal:life.signal});
    });
  }

  async function initializeCatalog(root) {
    if (root.dataset.flowReady) return;
    root.dataset.flowReady = 'true';
    const meta = JSON.parse(q('[data-catalog-config]', root).textContent);
    const grid = q('[data-catalog-grid]', root);
    const form = q('[data-forge-filters]', root);
    const status = q('[data-catalog-status]', root);
    const error = q('[data-catalog-error]', root);
    const more = q('[data-catalog-more]', root);
    const empty = q('[data-catalog-empty]', root);
    const nativePagination = q('[data-native-pagination]', root);
    const typeSelect = q('[data-filter-type]', form);
    const sizeSelect = q('[data-filter-size]', form);
    const sortSelect = q('[data-catalog-sort]', form);
    const facetDetails = q('[data-filter-details]', form);
    const filterNames = ['forge_type', 'forge_size', 'forge_min', 'forge_max', 'forge_stock'];
    let shown = 24, records = [], ready = false;
    const seen = new Set();
    const keys = Object.keys(cfg.types);
    const getRecords = scope => qa('[data-catalog-card]', scope).map(card => {
      const data = JSON.parse(q('[data-catalog-product]', card).textContent);
      const sizeIndex = data.options.findIndex((name, index) => /size|dimension/i.test(name) || data.variants.some(v => sizeLabel(v.options[index])));
      const sizes = [...new Set(data.variants.map(v => sizeLabel(v.options[sizeIndex])).filter(Boolean))];
      const types = keys.filter(key => data.collections.includes(key));
      if (!types.length && data.type) types.push(data.type);
      return {card, data, sizeIndex, sizes, types, index:0, originalPrice:q('.price', card).textContent, links:qa('a', card).map(link => [link, link.href])};
    });
    function addRecords(scope) {
      for (const record of getRecords(scope)) {
        if (seen.has(record.data.id)) continue;
        seen.add(record.data.id);
        record.index = records.length;
        records.push(record);
        if (!grid.contains(record.card)) grid.append(record.card);
      }
    }
    addRecords(root);
    function populate(select, values, label) {
      const current = select.value;
      select.replaceChildren(new Option(label, ''));
      for (const value of values) select.add(new Option(cfg.types[value] || value, value));
      if (values.includes(current)) select.value = current;
    }
    function restoreQuery() {
      const params = new URL(location.href).searchParams;
      for (const name of filterNames) {
        const field = form.elements.namedItem(name);
        const value = params.get(name) || '';
        if (field.tagName !== 'SELECT' || [...field.options].some(option => option.value === value)) field.value = value;
      }
      const sort = params.get('sort_by');
      if (sort && [...sortSelect.options].some(option => option.value === sort)) sortSelect.value = sort;
    }
    function persistQuery() {
      const url = new URL(location.href);
      for (const name of filterNames) {
        const value = form.elements.namedItem(name).value;
        if (value) url.searchParams.set(name, value);
        else url.searchParams.delete(name);
      }
      if (sortSelect.value && sortSelect.value !== 'relevance') url.searchParams.set('sort_by', sortSelect.value);
      else url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      history.replaceState({}, '', url);
    }
    function chosenState() {
      const values = Object.fromEntries(filterNames.map(name => [name, form.elements.namedItem(name).value]));
      values.min = values.forge_min === '' ? 0 : Number(values.forge_min) * 100;
      values.max = values.forge_max === '' ? Infinity : Number(values.forge_max) * 100;
      return values;
    }
    function matches(record, state) {
      if (state.forge_type && !record.types.includes(state.forge_type)) return false;
      let variants = record.data.variants.filter(v => !state.forge_size || sizeLabel(v.options[record.sizeIndex]) === state.forge_size);
      if (!variants.length) return false;
      const available = variants.some(v => v.available);
      if (state.forge_stock === 'available' && !available) return false;
      if (state.forge_stock === 'sold-out' && available) return false;
      if (available) variants = variants.filter(v => v.available);
      variants = variants.filter(v => v.price >= state.min && v.price <= state.max);
      if (!variants.length) return false;
      record.matchPrice = Math.min(...variants.map(v => v.price));
      record.matchVariant = variants.find(v => v.options.some(value => /^black(?: frame)?$/i.test(value))) || variants[0];
      return true;
    }
    function render(updateUrl = false) {
      const max = form.elements.namedItem('forge_max');
      max.setCustomValidity('');
      const state = chosenState();
      if (state.max < state.min) {
        max.setCustomValidity(cfg.priceInvalid);
        max.reportValidity();
        return;
      }
      const result = records.filter(record => matches(record, state));
      const sort = sortSelect.value;
      result.sort((a, b) => {
        if (sort === 'price-ascending') return a.matchPrice - b.matchPrice || a.index - b.index;
        if (sort === 'price-descending') return b.matchPrice - a.matchPrice || a.index - b.index;
        if (sort === 'created-descending') return Number(b.data.created) - Number(a.data.created) || a.index - b.index;
        if (sort === 'created-ascending') return Number(a.data.created) - Number(b.data.created) || a.index - b.index;
        if (sort === 'title-ascending') return a.data.title.localeCompare(b.data.title);
        if (sort === 'title-descending') return b.data.title.localeCompare(a.data.title);
        return a.index - b.index;
      });
      for (const record of records) record.card.hidden = true;
      for (const [index, record] of result.entries()) {
        record.card.hidden = index >= shown;
        grid.append(record.card);
        q('.price', record.card).textContent = state.forge_size ? cfg.sizePrice + ' ' + money(record.matchPrice) : record.originalPrice;
        for (const [link, original] of record.links) {
          const url = new URL(original);
          if (state.forge_size && record.matchVariant) url.searchParams.set('variant', record.matchVariant.id);
          link.href = url.toString();
        }
      }
      empty.hidden = result.length > 0 || !ready;
      more.hidden = !ready || result.length <= shown;
      status.textContent = ready ? fill(cfg.count, {shown:Math.min(shown, result.length), count:result.length}) : cfg.loading;
      const active = filterNames.filter(name => form.elements.namedItem(name).value !== '');
      q('[data-filter-count]', form).textContent = active.length ? '(' + active.length + ')' : '';
      const chips = q('[data-active-filters]', root);
      chips.replaceChildren();
      for (const name of active) {
        const field = form.elements.namedItem(name);
        let label = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : money(Number(field.value) * 100);
        if (name === 'forge_min') label = cfg.minPrice + ' ' + label;
        if (name === 'forge_max') label = cfg.maxPrice + ' ' + label;
        const chip = make('button', label + ' ×', 'forge-filter-chip');
        chip.type = 'button';
        chip.setAttribute('aria-label', cfg.removeFilter + ' ' + label);
        chip.addEventListener('click', () => {field.value = ''; shown = 24; render(true);});
        chips.append(chip);
      }
      if (updateUrl) persistQuery();
    }
    function configureControls() {
      populate(typeSelect, [...new Set(records.flatMap(record => record.types))].sort(), cfg.allTypes);
      populate(sizeSelect, [...new Set(records.flatMap(record => record.sizes))].sort((a, b) => parseFloat(a) - parseFloat(b) || a.localeCompare(b)), cfg.allSizes);
      restoreQuery();
      facetDetails.hidden = false;
      facetDetails.open = false;
      ready = true;
      if (nativePagination) nativePagination.hidden = true;
      render();
    }
    form.addEventListener('submit', event => {
      if (ready) {event.preventDefault(); shown = 24; render(true);}
    }, {signal:life.signal});
    form.addEventListener('change', event => {
      if (!ready) return;
      if (event.target === sortSelect && ['best-selling', 'manual', 'most-relevant'].includes(sortSelect.value) && meta.sort !== sortSelect.value) {
        persistQuery();
        location.assign(new URL(location.href).toString());
        return;
      }
      shown = 24;
      render(true);
    }, {signal:life.signal});
    q('[data-clear-filters]', form).addEventListener('click', () => {
      for (const name of filterNames) form.elements.namedItem(name).value = '';
      shown = 24;
      render(true);
    }, {signal:life.signal});
    more.addEventListener('click', () => {
      const previous = shown;
      shown += 24;
      render();
      q('a', [...grid.children].filter(card => !card.hidden)[previous])?.focus({preventScroll:true});
    }, {signal:life.signal});
    window.addEventListener('popstate', () => {if (ready) {restoreQuery(); shown = 24; render();}}, {signal:life.signal});
    render();
    try {
      for (let page = 1; page <= meta.pages; page++) {
        if (page === meta.page) continue;
        const url = new URL(location.href);
        url.searchParams.set('page', page);
        url.searchParams.set('section_id', root.dataset.section);
        url.searchParams.set('preview_theme_id', root.dataset.theme);
        const response = await fetch(url, {credentials:'same-origin', signal:life.signal});
        if (!response.ok) throw new Error('catalog');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!q('[data-catalog-grid]', html)) throw new Error('catalog');
        addRecords(html);
      }
      configureControls();
    } catch (failure) {
      if (failure.name === 'AbortError') return;
      error.textContent = cfg.catalogError;
      for (const record of records) record.card.hidden = false;
      status.textContent = cfg.catalogFallback;
      more.hidden = true;
      if (nativePagination) nativePagination.hidden = false;
    }
  }

  function initializeGallery(root) {
    const gallery = q('[data-forge-gallery]', root);
    if (!gallery || gallery.dataset.flowReady) return;
    gallery.dataset.flowReady = 'true';
    const controls = q('[data-gallery-controls]', root);
    const thumbnails = q('[data-gallery-thumbnails]', root);
    let media = [...gallery.children], selected = 0, frame;
    gallery.tabIndex = 0;
    gallery.id = 'Gallery-' + q('.product-form', root).id;
    const thumbs = media.map((item, index) => {
      const button = make('button', null, 'forge-media-thumb');
      button.type = 'button';
      button.setAttribute('aria-controls', gallery.id);
      button.setAttribute('aria-label', fill(cfg.gotoMedia, {number:index + 1}));
      const image = q('img', item);
      const video = q('video', item);
      const source = image?.getAttribute('src') || video?.getAttribute('poster');
      if (source) {
        const thumb = make('img');
        thumb.src = source;
        thumb.alt = '';
        thumb.width = 64;
        thumb.height = 64;
        thumb.loading = 'lazy';
        button.append(thumb);
      } else button.append(make('span', String(index + 1)));
      if (video) button.append(make('span', '▶', 'forge-video-mark'));
      button.addEventListener('click', () => go(index), {signal:life.signal});
      button.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = Math.max(0, Math.min(media.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        go(next);
        thumbs[next].focus({preventScroll:true});
      }, {signal:life.signal});
      thumbnails.append(button);
      return button;
    });
    function announce() {
      q('[data-gallery-status]', root).textContent = fill(cfg.mediaCount, {number:selected + 1, count:media.length});
      thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', String(index === selected));
        thumb.tabIndex = index === selected ? 0 : -1;
      });
      q('[data-gallery-prev]', root).disabled = selected === 0;
      q('[data-gallery-next]', root).disabled = selected === media.length - 1;
      media.forEach((item, index) => {if (index !== selected) q('video', item)?.pause();});
    }
    function go(index) {
      selected = Math.max(0, Math.min(media.length - 1, index));
      gallery.scrollTo({left:media[selected].offsetLeft - media[0].offsetLeft, behavior:motion.matches ? 'instant' : 'smooth'});
      announce();
      thumbs[selected].scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
    }
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const previous = selected;
        selected = media.reduce((best, item, index) => Math.abs(item.offsetLeft - media[0].offsetLeft - gallery.scrollLeft) < Math.abs(media[best].offsetLeft - media[0].offsetLeft - gallery.scrollLeft) ? index : best, 0);
        if (previous !== selected) announce();
      });
    }, {passive:true, signal:life.signal});
    gallery.addEventListener('keydown', event => {
      if (event.target !== gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      go(selected + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal:life.signal});
    q('[data-gallery-prev]', root).addEventListener('click', () => go(selected - 1), {signal:life.signal});
    q('[data-gallery-next]', root).addEventListener('click', () => go(selected + 1), {signal:life.signal});
    root.addEventListener('forge:selection-change', event => {
      const id = event.detail.variant?.featured_media?.id;
      const index = media.findIndex(item => item.dataset.mediaId === String(id));
      if (index >= 0 && index !== selected) go(index);
    }, {signal:life.signal});
    controls.hidden = media.length < 2;
    thumbnails.hidden = media.length < 2;
    announce();
  }

  function initializeFactsAndSticky(root) {
    if (root.dataset.flowFacts) return;
    root.dataset.flowFacts = 'true';
    const variants = JSON.parse(q('[data-product-json]', root).textContent);
    const names = JSON.parse(q('[data-options-json]', root).textContent);
    const form = q('.product-form', root);
    const source = q('[data-variant-id]', root);
    const add = q('.buy-button', form);
    const sticky = q('[data-sticky-buy]', root);
    const stickyButton = q('button', sticky);
    const smallScreen = window.matchMedia('(max-width: 979px)');
    const description = q('[data-piece-description]', root).textContent;
    const fixedDimensions = description.match(/(?:approximately|approx\.?|about|roughly)\s+(\d+(?:\.\d+)?(?:\s*[x×–-]\s*\d+(?:\.\d+)?)?\s*(?:inches|inch|in\b|[”"″])(?:\s*(?:tall|long|wide|in diameter))?)/i)?.[1] || description.match(/(\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*(?:inches|inch|in\b))/i)?.[1];
    let addVisible = false;
    function visibility() {
      sticky.hidden = !smallScreen.matches || addVisible;
      document.body.classList.toggle('forge-has-sticky-buy', !sticky.hidden);
    }
    function update(variant, total) {
      if (!variant) return;
      const title = variant.title === 'Default Title' ? cfg.singlePiece : variant.title;
      const configuration = q('[data-selected-configuration]', root);
      if (configuration) configuration.textContent = title;
      const dimensions = variant.options.map(sizeLabel).find(Boolean) || fixedDimensions;
      const row = q('[data-dimensions-row]', root);
      row.hidden = !dimensions;
      if (dimensions) q('[data-selected-dimensions]', row).textContent = dimensions;
      const frameIndex = names.findIndex(name => /frame|display/i.test(name) && !/stand/i.test(name));
      const standIndex = names.findIndex(name => /stand/i.test(name));
      const chosenFrame = frameIndex >= 0 ? variant.options[frameIndex] : '';
      const choseFrame = chosenFrame && !/artwork only|no frame|none|unframed/i.test(chosenFrame);
      const stand = q('[data-pdp-easel]', root)?.checked || (standIndex >= 0 && !/no stand|none/i.test(variant.options[standIndex]));
      const included = q('[data-selected-inclusions]', root);
      included.textContent = choseFrame ? fill(cfg.withFrame, {frame:chosenFrame}) : cfg.includedNote;
      if (stand) included.textContent += ' ' + cfg.withStand;
      q('[data-sticky-configuration]', root).textContent = title;
      q('[data-sticky-total]', root).textContent = money(total ?? variant.price * Math.max(1, Number(q('[name=quantity]', form).value) || 1));
      stickyButton.disabled = add.disabled;
      stickyButton.textContent = add.textContent;
      stickyButton.setAttribute('aria-label', add.textContent + ', ' + title + ', ' + q('[data-sticky-total]', root).textContent);
    }
    update(variants.find(variant => String(variant.id) === source.value));
    root.addEventListener('forge:selection-change', event => update(event.detail.variant, event.detail.total), {signal:life.signal});
    document.addEventListener('forge:cart-busy', () => {
      stickyButton.disabled = add.disabled;
      stickyButton.textContent = add.textContent;
    }, {signal:life.signal});
    const observer = new IntersectionObserver(entries => {addVisible = entries[0].isIntersecting; visibility();}, {threshold:0.2});
    observer.observe(add);
    smallScreen.addEventListener('change', visibility, {signal:life.signal});
    life.signal.addEventListener('abort', () => observer.disconnect(), {once:true});
    const errors = new MutationObserver(() => {
      if (q('[data-product-error]', root).textContent) q('[data-product-error]', root).scrollIntoView({block:'center', behavior:motion.matches ? 'instant' : 'smooth'});
    });
    errors.observe(q('[data-product-error]', root), {childList:true, subtree:true, characterData:true});
    life.signal.addEventListener('abort', () => errors.disconnect(), {once:true});
    visibility();
  }

  function initializeShipping(scope) {
    qa('[data-shipping-form]', scope).forEach(form => {
      if (form.dataset.flowReady) return;
      form.dataset.flowReady = 'true';
      const country = q('[data-shipping-country]', form);
      const province = q('[data-shipping-province]', form);
      const provinceField = q('[data-shipping-province-field]', form);
      const zip = q('[name=zip]', form);
      const status = q('[data-shipping-status]', form);
      const list = q('[data-shipping-rates]', form);
      const submit = q('button[type=submit]', form);
      let request = null, checked = false;
      if ([...country.options].some(option => option.value === country.dataset.default)) country.value = country.dataset.default;
      function invalidate() {
        const hadEstimate = checked || request;
        request?.abort();
        request = null;
        checked = false;
        list.replaceChildren();
        if (hadEstimate) status.textContent = cfg.ratesChanged;
        submit.disabled = false;
      }
      function provinces() {
        invalidate();
        const regions = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        province.replaceChildren();
        for (const [value, label] of regions) province.add(new Option(label, value));
        provinceField.hidden = !regions.length;
        province.disabled = !regions.length;
        checked = false;
        list.replaceChildren();
        status.textContent = '';
      }
      country.addEventListener('change', provinces, {signal:life.signal});
      province.addEventListener('change', invalidate, {signal:life.signal});
      zip.addEventListener('input', invalidate, {signal:life.signal});
      provinces();
      document.addEventListener('forge:cart-updated', invalidate, {signal:life.signal});
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        request?.abort();
        const currentRequest = new AbortController();
        request = currentRequest;
        const params = new URLSearchParams({'shipping_address[country]':country.value, 'shipping_address[zip]':zip.value.trim()});
        if (!province.disabled) params.set('shipping_address[province]', province.value);
        submit.disabled = true;
        status.textContent = cfg.ratesLoading;
        list.replaceChildren();
        try {
          const cartResponse = await fetch(rootPath + 'cart.js', {credentials:'same-origin', signal:currentRequest.signal});
          const cart = await cartResponse.json();
          if (!cartResponse.ok || !cart.item_count) {
            status.textContent = cfg.ratesEmpty;
            return;
          }
          const start = await fetch(rootPath + 'cart/prepare_shipping_rates.json?' + params, {method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, signal:currentRequest.signal});
          if (!start.ok) throw new Error('rates');
          let result = null;
          for (let attempt = 0; attempt < 12; attempt++) {
            const response = await fetch(rootPath + 'cart/async_shipping_rates.json?' + params, {credentials:'same-origin', headers:{Accept:'application/json'}, signal:currentRequest.signal});
            if (!response.ok) throw new Error('rates');
            result = await response.json();
            if (result !== null) break;
            await new Promise((resolve, reject) => {
              const timer = setTimeout(resolve, 700);
              currentRequest.signal.addEventListener('abort', () => {clearTimeout(timer); reject(new DOMException('Aborted', 'AbortError'));}, {once:true});
            });
          }
          if (!result) throw new Error('rates');
          checked = true;
          const rates = result.shipping_rates || [];
          for (const rate of rates) list.append(make('li', (rate.presentment_name || rate.name) + ': ' + money(Math.round(Number(rate.price) * 100))));
          status.textContent = rates.length ? cfg.ratesReady : cfg.ratesNone;
        } catch (failure) {
          if (failure.name !== 'AbortError') status.textContent = cfg.ratesError;
        } finally {
          if (request === currentRequest) submit.disabled = false;
        }
      }, {signal:life.signal});
      life.signal.addEventListener('abort', () => request?.abort(), {once:true});
    });
  }

  function initializeHelp() {
    const dialog = q('#ForgeQuickHelp');
    if (!dialog) return;
    let lastFocus;
    q('[data-forge-help-open]').addEventListener('click', event => {
      event.preventDefault();
      lastFocus = document.activeElement;
      dialog.showModal();
      q('[data-forge-help-close]', dialog).focus();
    }, {signal:life.signal});
    q('[data-forge-help-close]', dialog).addEventListener('click', () => dialog.close(), {signal:life.signal});
    dialog.addEventListener('close', () => lastFocus?.focus(), {signal:life.signal});
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    }, {signal:life.signal});
  }

  function initialize(scope) {
    initializeMenus(scope);
    qa('[data-forge-catalog]', scope).forEach(initializeCatalog);
    qa('[data-product-root]', scope).forEach(root => {initializeGallery(root); initializeFactsAndSticky(root);});
    initializeShipping(scope);
  }
  initialize(document);
  initializeHelp();
  document.addEventListener('shopify:section:load', event => initialize(event.target), {signal:life.signal});
})();
